import React from 'react';
import PlayerHUD from '../../PlayerHUD';
import {
  MOBILE_PLAYER_HUD_BOTTOM_PX,
  MOBILE_PLAYER_HUD_LEFT_PX,
} from '../mobile/mobileBattleLayoutOffsets';
import './BattlePlayerHudPanel.css';

/**
 * Player HUD (desktop + mobile battle).
 * Mobile: position wrapper only; scale via PlayerHUD --hud-scale (OpponentHUD pattern).
 */
export default function BattlePlayerHudPanel({ mobileLayout = false, ...playerHudProps }) {
  if (mobileLayout) {
    return (
      <div
        className="player-hud-outer player-hud-outer--mobile"
        data-mobile-player-hud="true"
        data-no-battle-flashlight="true"
        style={{
          position: 'absolute',
          left: MOBILE_PLAYER_HUD_LEFT_PX,
          bottom: MOBILE_PLAYER_HUD_BOTTOM_PX,
          zIndex: 1004,
        }}
      >
        <PlayerHUD {...playerHudProps} mobileLayout />
      </div>
    );
  }

  return <PlayerHUD {...playerHudProps} />;
}
